import { useI18n } from "components/lni18n";
import { Button, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import ImagePicker from "./ImagePicker";

class ImagePickerService {

  onSubmit = null;
  submitBrooker = (res) => {
    if( this.onSubmit) {
      this.onSubmit(res);
    }
  }

}

/**
 * 
 * @param {{onSubmit:Function, onCancel: Function}} props
 */
const ImagePickerDialog = ({ onSubmit, onCancel }) => {

  const { languageService: t } = useI18n();


  return <>
      <ModalHeader className={""} toggle={()=>onCancel()}>{t.getText("image")}</ModalHeader>
      <ModalBody className={""} tabIndex={-1}>
        <ImagePicker onSubmit={onSubmit} />
      </ModalBody>
      <ModalFooter>

        <Button className="btn btn-inverse" onClick={()=>onCancel()}>{t.getText("close")}</Button>
      </ModalFooter>
  </>

}

export const imagePickerService = new ImagePickerService();
export default ImagePickerDialog;
